/*
 * @Author: mayanxia 
 * @Date: 2020-11-07 19:54:06 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2021-12-22 10:28:39
 */

<template>
  <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :hidden="seen" :label="$t('上级区域')" hasFeedback prop="areaParentId">
              <a-tree-select
                style="width:100%"
                :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
                :treeData="treeData"
                v-model="model.areaParentId"
                :placeholder="$t('请选择上级区域')"
                :disabled="condition">
              </a-tree-select>
            </a-form-model-item>
          </a-col>
          <!--
          <a-col :span="24">
            <a-form-model-item label="区域编号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaId">
              <a-input v-model="model.areaId" placeholder="请输入区域编号"></a-input>
            </a-form-model-item>
          </a-col
          -->
          <a-col :span="24">
            <a-form-model-item :label="$t('区域名称')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaName">
              <a-input v-model="model.areaName" :placeholder="$t('请输入区域名称')"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item :label="$t('负责人')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaManager">
              <a-input v-model="model.areaManager" :placeholder="$t('请输入负责人')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('负责人电话')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaTel">
              <a-input v-model="model.areaTel" :placeholder="$t('请输入负责人电话')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('小区备注信息')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaRemark">
              <a-textarea v-model="model.areaRemark" rows="4" :placeholder="$t('请输入小区备注信息')"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import {queryAreaTreeList} from '@/api/api'
  import pick from 'lodash.pick'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  export default {
    name: "SysDepartModal",
    components: { ATextarea },
    data () {
      return {
        treeData:[],
        phoneWarning:'',
        seen:false,
        visible: false,
        condition:true,
        disableSubmit:false,
        model: {
          //areaId: '',
          areaName: '',
          areaTel: '',
          areaParentId: '',
          areaManager: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterArea/add"
        }
      }
    },
    computed: {
      // i18n：标题/校验消息使用 computed 以响应语言切换
      title () {
        return this.$t('操作')
      },
      rules() {
        return {
          //areaId:[{ required: true, message: '请输入区域编码!'}],
          areaName: [{required: true, message: this.$t('请输入区域/小区名称!')}],
          areaTel: [{validator: this.validateMobile}]
        }
      },
    },
    created () {
    },
    methods: {
      loadTreeData() {
        var that = this;
        queryAreaTreeList().then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            that.treeData = []
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
            }
          }
        })
      },
      add (depart) {
        if(depart){
          this.seen = false;
        }else{
          this.seen = true;
        }
        this.edit(depart);
      },
      edit (record) {
        this.treeData = []
        this.model = Object.assign(this.model, {});
        this.visible = true;
        this.loadTreeData();
        this.$nextTick(() => {
          this.$refs.formModal.resetFields();
          this.model.areaParentId = record!==null?record.toString():null;
        })
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            httpAction(this.url.add,this.model,"post").then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.error(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateMobile(rule,value,callback){
        if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)){
          callback();
        }else{
          callback(this.$t("您的手机号码格式不正确!"));
        }
      },
      
    }
  }
</script>

<style scoped>

</style>